module.exports = __webpack_public_path__ + "static/media/globo-compuerta-01.8e44f7c4.jpg";